/**
 * Resume templates in HTML format
 * Each template function takes resumeData and returns HTML
 */

import standardTemplateHtml from "./standardTemplateHtml";
import modernTemplateHtml from "./modernTemplateHtml";
import minimalistTemplateHtml from "./minimalistTemplateHtml";
// import executiveTemplateHtml from "./executiveTemplateHtml";

// Export all templates
export const templates = {
  standard: {
    name: "Standard",
    description: "Traditional resume format",
    generator: standardTemplateHtml,
  },
  modern: {
    name: "Modern",
    description: "Two-column layout with sidebar",
    generator: modernTemplateHtml,
  },
  minimalist: {
    name: "Minimalist",
    description: "Clean, simple design",
    generator: minimalistTemplateHtml,
  },
  // executive: {
  //   name: "Executive",
  //   description: "Professional design for senior positions",
  //   generator: executiveTemplateHtml,
  // },
};

// Function to get all templates
export const getTemplates = () => {
  return Object.entries(templates).map(([id, template]) => ({
    id,
    name: template.name,
    description: template.description,
    generator: template.generator, // Include the generator function
  }));
};

// Export individual templates
export {
  standardTemplateHtml,
  modernTemplateHtml,
  minimalistTemplateHtml,
  // executiveTemplateHtml,
};

export default templates;
